<div class="hero flex justify-between items-center h-3xl">
  <div class="action-items space-x-md mx-md">
    <button class="btn btn-primary" routerLink="/events">Watch Event</button>
    <button class="btn btn-primary" routerLink="/login">Sign In</button>
    <button class="btn btn-primary">Sign Up</button>
  </div>
  <div class="log">
    <img src="/assets/logo/logoIcon.png" alt="" />
  </div>
</div>

<div class="content flex space-x-1xl mx-1xl mt-xl">
  <div class="card">
    <div class="card-image"><img src="/assets/home/education.png" alt="" /><span class="content">Education</span></div>
    <div class="card-content">
      <p>
        VZP Digital can provide realtime captions utilizing either CART certified stenographers, or Artificial
        Intelligence driven automated captioning. Or both. VZP's REACH platform can uniquely provide either or both in a
        seemless integration to you.
      </p>
    </div>
  </div>
  <div class="card">
    <div class="card-image">
      <img src="/assets/home/sporting_venues.png" alt="" /><span class="content">Sporting Venues</span>
    </div>
    <div class="card-content">
      <p>
        VZP Digital can provide realtime captions utilizing either CART certified stenographers, or Artificial
        Intelligence driven automated captioning. Or both. VZP's REACH platform can uniquely provide either or both in a
        seemless integration to you.
      </p>
    </div>
  </div>
  <div class="card">
    <div class="card-image">
      <img src="/assets/home/tv_broadcasts.png" alt="" /><span class="content">TV Broadcasts</span>
    </div>
    <div class="card-content">
      <p>
        VZP Digital can provide realtime captions utilizing either CART certified stenographers, or Artificial
        Intelligence driven automated captioning. Or both. VZP's REACH platform can uniquely provide either or both in a
        seemless integration to you.
      </p>
    </div>
  </div>
</div>
